import React from 'react'
import {
  Chat,
  TranslationDictionary,
  SERVICES_URL,
  useLocale
} from '@plandi/common'
import { useRouter } from 'next/router'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import { URLS } from 'src/common'
import { MainLayoutContent, MainLayoutSidebar } from 'src/features/layouts'
import {
  useMutationSendMessageProjectChat,
  useQueryProjectChatMessagesByChatId
} from 'src/features/projects/common'
import { useProjectChatStyles } from './project-chat.styles'
import { ProfileDetails } from 'src/features/profile-details'
import { isEmpty } from 'lodash-es'
import { Link } from '@material-ui/core'

type ProjectChatProps = {
  translate?: TranslationDictionary['data']
  locale: string
}

export const ProjectChat: React.FC<ProjectChatProps> = ({ translate }) => {
  const classes = useProjectChatStyles()
  const router = useRouter()
  const locale = useLocale()
  const url = SERVICES_URL

  const chatId = router.query.chatId ? Number(router.query.chatId) : undefined

  const { data: projectChatMessages, isLoading } =
    useQueryProjectChatMessagesByChatId(chatId)

  const mutationSendMessageProjectChat =
    useMutationSendMessageProjectChat(chatId)

  const messages = projectChatMessages?.messages?.map((message) => ({
    id: message.id,
    text: message.content,
    createdAt: message.createdAt,
    avatarUrl: message.senderAvatarUrl,
    isAuthor: message.isAuthor
  }))

  const linkBlock = () => {
    return (
      <div style={{ display: 'flex', gap: 5 }}>
        <Typography style={{ fontSize: 13 }}>
          {locale === 'ru' ? 'Чат заблокирован.' : 'Chat blocked.'}
        </Typography>
        <Link
          href={
            locale === 'ru'
              ? `${url.main}/ru/messages?tab=shop&type=projects&page=1`
              : url.main + '/messages?tab=shop&type=projects&page=1'
          }
        >
          {locale === 'ru' ? 'Управление чатами' : 'Chat management'}
        </Link>
      </div>
    )
  }

  return (
    <>
      <MainLayoutSidebar size="large">
        <ProfileDetails
          userPage
          profileType={
            isEmpty(projectChatMessages?.profile) ? 'user' : undefined
          }
          projectsProfile={
            projectChatMessages?.profile ?? projectChatMessages?.user
          }
          loadingProfile={isLoading}
        />
      </MainLayoutSidebar>
      <MainLayoutContent>
        <div className={classes.titleContainer}>
          <Typography variant="h5" component="h1">
            {projectChatMessages?.projectName}
          </Typography>
          <Link
            onClick={() =>
              router.push({
                pathname: URLS.projects.detail,
                query: {
                  projectId: router.query.projectId,
                  slugName: router.query.slugName
                }
              })
            }
          >
            <Button
              color="primary"
              variant="contained"
              className={classes.button}
            >
              {translate?.shop.header.project}
            </Button>
          </Link>
        </div>
        <Chat
          translate={translate}
          messages={messages}
          isLoading={isLoading}
          disabled={projectChatMessages?.status === 'decline'}
          onSendMessage={(values) =>
            mutationSendMessageProjectChat.mutateAsync(values.message)
          }
          informationMessages={
            !projectChatMessages?.messages?.length
              ? [translate?.shop['no-messages']]
              : projectChatMessages?.status === 'decline'
              ? [linkBlock()]
              : []
          }
        />
      </MainLayoutContent>
    </>
  )
}
